import {
  CONSENT_MAX_AGE_MS,
  CONSENT_VERSION,
  readConsentChoice,
} from './choice';

export const ANALYTICS_CONSENT_HEADER = 'x-directordeck-analytics-consent';

/** Send the current browser choice through Firebase Hosting, which strips ordinary cookies. */
export function getAnalyticsConsentRequestHeaders(): Record<string, string> {
  const choice = readConsentChoice();
  if (!choice) return {};

  return {
    [ANALYTICS_CONSENT_HEADER]: JSON.stringify({
      version: choice.version,
      savedAt: choice.savedAt,
      analytics: choice.analytics,
    }),
  };
}

export function hasCurrentAnalyticsConsent(
  evidence: string | string[] | undefined,
): boolean {
  if (typeof evidence !== 'string') return false;

  try {
    const parsed: unknown = JSON.parse(evidence);
    if (!parsed || typeof parsed !== 'object') return false;
    const choice = parsed as Record<string, unknown>;
    const age = Date.now() - Number(choice.savedAt);
    return (
      choice.version === CONSENT_VERSION &&
      choice.analytics === true &&
      typeof choice.savedAt === 'number' &&
      Number.isFinite(age) &&
      age >= 0 &&
      age < CONSENT_MAX_AGE_MS
    );
  } catch {
    return false;
  }
}
